export const STAGING_PUBLIC_PATH =
	'https://dev-agents.stg-east.frontend.public.atl-paas.net/assets/';
export const PROD_PUBLIC_PATH = 'https://dev-agents.prod-east.frontend.public.atl-paas.net/assets/';
export const STG_BITBUCKET_DOMAIN = 'integration.bb-inf.net';
export const PROD_BITBUCKET_DOMAIN = 'bitbucket.org';
export const BITBUCKET_SETUP_GUIDE_LINK =
	'https://support.atlassian.com/jira-cloud-administration/docs/integrate-bitbucket-with-jira/';
export const GITHUB_INSTALL_LINK =
	'https://marketplace.atlassian.com/apps/1219592/github-for-jira?tab=overview&hosting=cloud';
export const GITHUB_SETUP_GUIDE_LINK =
	'https://support.atlassian.com/jira-cloud-administration/docs/integrate-with-github/';
export const BITBUCKET_MANAGE_LINK = '/secure/admin/ConfigureDvcsOrganizations!default.jspa';
export const CODING_AGENTS_LEARN_MORE_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/ZmEwZmU2MTYwMGM3NDE3NjhlOTA2MDZhNGY5ZmU0OTU';
export const CODE_PLANNER_LEARN_MORE_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/NmYzMTZiZjhkOGQ1NGY5NTgzZDlkYjhlNjdhZjFjYWM';
export const CODE_REVIEWER_LEARN_MORE_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/YWJmZmRiNTFhYTUxNDBhOTg5ZjY5ZmQ0Yzg5MTlkNzA';
export const DEPLOYMENT_SUMMARIZER_LEARN_MORE_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/OWYyYTFhNGEyNGUwNGY3YjgwMzkxMDhhMTAzM2EwYzc';
export const BBC_AGENTS_SETTINGS_LINK_PROD = 'https://bitbucket.org/account/workspaces/';
export const BBC_AGENTS_SETTINGS_LINK_STG = 'https://integration.bb-inf.net/account/workspaces/';
export const PIPELINE_TROUBLESHOOTER_LEARN_MORE_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/ZjBjMmQ3YmQzOThhNDY1MGEzZjRiMjM1NzA5YmNkZTU';
export const CODE_SEARCH_LEARN_MORE_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/NzJlM2JlYjRmZTc1NGQ1NTk5NjUwNDFkYmE3NTZiODY';
export const ROVO_DEV_CLI_LEARN_MORE_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/OWY5NjhmMDIyNjgzNDkxY2IyNjk4OTViOGIzZjM4ZDc';
export const ADMIN_HUB_BASE_URL_PROD = 'https://admin.atlassian.com';
export const ADMIN_HUB_BASE_URL_STG = 'https://admin.stg.atlassian.com';
export const GITHUB_MANAGE_LINK_PROD =
	'/plugins/servlet/ac/com.github.integration.production/gh-addon-admin?s=com.github.integration.production__gh-addon-admin';
export const GITHUB_MANAGE_LINK_STG =
	'/plugins/servlet/ac/com.github.integration.staging/gh-addon-admin?s=com.github.integration.staging__gh-addon-admin';
export const DEPLOYMENT_SUMMARIZER_SETTINGS_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/ZTk0Y2QzMmFmMDVlNDNjNzlkYjg5YjUyOWJhOTIyZTQ';
export const PIPELINE_TROUBLESHOOTER_SETTINGS_LINK =
	'https://rovodevagents-beta.atlassian.net/wiki/external/NTgwMGQ3Yzg1ZThjNDQ5ZDhmZWYyNWVjN2ZjODExNmM';
export const JOIN_WAITLIST_LINK =
	'https://rovodevagents.atlassian.net/servicedesk/customer/portal/1';
export const ROVO_DEV_CLI_READ_MORE_URL =
	'https://rovodevagents-beta.atlassian.net/wiki/external/Yzc2NzI4MTk3YTBhNDdiYjkzZDhhZTc3MjE0ZmE4Y2Q';
export const ROVO_DEV_CLI_INTRO_URL =
	'https://developer.atlassian.com/cloud/acli/guides/introduction/';
export const ROVO_DEV_CLI_MAC_INSTRUCTIONS_URL =
	'https://developer.atlassian.com/cloud/acli/guides/install-macos/';
export const ROVO_DEV_CLI_LINUX_INSTRUCTIONS_URL =
	'https://developer.atlassian.com/cloud/acli/guides/install-linux/';
export const ROVO_DEV_CLI_WINDOWS_INSTRUCTIONS_URL =
	'https://developer.atlassian.com/cloud/acli/guides/install-windows/';
export const ROVO_DEV_CLI_TOKENS_URL =
	'https://id.atlassian.com/manage-profile/security/api-tokens';
export const ROVO_DEV_CLI_BETA_LEARN_MORE_URL =
	'https://rovodevagents-beta.atlassian.net/wiki/external/ZDQxM2VhODI2MjJkNDI3M2IwMjgyNzNjZWIwYjJhYTM';
